import React from "react";
import styles from './LineImg.module.scss';
import LazyImage from 'gui/components/LazyImage/LazyImage';

export interface IPlaneIconProps {
}

const LineImg = (props: IPlaneIconProps) => (
  <LazyImage
    className={styles.LineImg}
    alt="time of flight"
    src="/img/line.svg"
  />
);

LineImg.defaultProps = {};

export default LineImg;
